import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './assets/base.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {reducer, initialState} from './reducers/reducer'
import { Provider } from 'react-redux';
import configureStore from './config/configureStore';

const store = configureStore();
const rootElement = document.getElementById('root');

const renderApp = Component => {

ReactDOM.render(
  <Provider store={store} initialState={initialState} reducer={reducer}>
      <App />
    </Provider>,
       rootElement
  );
};

renderApp(App)

if (module.hot) {
  module.hot.accept('./Pages/supplier/LandingPage', () => {
    const NextApp = require('./Pages/supplier/LandingPage').default;
    renderApp(NextApp);
  });
}
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
